module.exports = __webpack_public_path__ + "fonts/e60a51b.ttf";